// extracted by mini-css-extract-plugin
export var container = "Suppliers-module--container--uS3AW";
export var content = "Suppliers-module--content--igar5";
export var noSuppliers = "Suppliers-module--noSuppliers--jfDAf";
export var subHeader = "Suppliers-module--subHeader--lWDAd";